import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContactSearchField = styled(TextField)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 60,
  backgroundColor: theme.palette.grey[200],
  border: 0,
}));
